var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_1797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8591 6.66488L14.8595 6.66359L22.6268 11.3744L27.2551 9.40226C28.1956 8.99057 29.2098 8.77947 30.2344 8.78049C30.4051 8.78049 30.5739 8.78833 30.7417 8.79967C30.1853 6.6027 29.0106 4.61666 27.3604 3.08292C25.7102 1.54917 23.6556 0.533745 21.4462 0.160034C19.2367 -0.213677 16.9677 0.0704176 14.9148 0.977794C12.8618 1.88517 11.1133 3.37676 9.88184 5.27131C9.9214 5.27081 9.96037 5.26829 10 5.26829C11.7167 5.26594 13.3997 5.74968 14.8591 6.66488Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8594 6.66362L14.8591 6.66491C13.3997 5.74971 11.7166 5.26596 10 5.26832C9.96034 5.26832 9.92132 5.27084 9.88179 5.27134C8.20165 5.2924 6.55893 5.77663 5.13017 6.67199C3.70141 7.56736 2.54063 8.84001 1.77255 10.3532C1.00448 11.8663 0.658159 13.5628 0.770805 15.2603C0.88345 16.9578 1.45081 18.5921 2.4119 19.9877L9.26152 17.0691L12.3064 15.7717L19.0861 12.883L22.6267 11.3744L14.8594 6.66362Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7419 8.79965C30.5741 8.7883 30.4053 8.78046 30.2346 8.78046C29.21 8.77945 28.196 8.99134 27.2555 9.40303L22.627 11.3743L23.9691 12.1883L28.3685 14.8566L30.288 16.0207L36.8513 20.0013C37.4476 18.8803 37.7567 17.6258 37.7501 16.3525C37.7436 15.0793 37.4216 13.8281 36.8137 12.7135C36.2058 11.5989 35.3314 10.6566 34.2706 9.97278C33.2098 9.289 31.9966 8.88563 30.7419 8.79965Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.288 16.0207L28.3685 14.8566L23.9691 12.1884L22.6269 11.3744L19.0863 12.883L12.3066 15.7717L9.26173 17.0691L2.41211 19.9876C3.2633 21.2268 4.39803 22.2389 5.71939 22.9376C7.04075 23.6363 8.5095 24.0008 10.0002 24H30.2346C31.5913 24.0004 32.9228 23.6289 34.0877 22.9249C35.2527 22.2208 36.2076 21.2106 36.8512 20.0013L30.288 16.0207Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_1797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/oneDrive.24fc71e33c7749782951914ba1314719.svg";
export { ForwardRef as ReactComponent };